export default __webpack_public_path__ + "static/media/fake-team.6c259e18.png";